import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'validate.js';

import BreederProfilePhotosCarousel from 'dpl/components/BreederProfile/mobile/components/about/BreederProfilePhotosCarousel';
import Divider from 'dpl/components/BreederProfile/mobile/components/shared/Divider';
import BreederProfilePhotosCarouselSectionSkeleton from 'dpl/components/BreederProfile/Show/skeletons/BreederProfilePhotosCarouselSectionSkeleton';
import { createBreederProfilePaginationAction } from 'dpl/containers/BreederProfile/Show/BreederProfilePhotoAlbumContainer';
import { PHOTO_ALBUM_TYPES } from 'dpl/shared/constants/breeder_app';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { groupBy } from 'dpl/shared/utils';
import { photographsResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';

const PREVIEW_CATEGORIES = [
  PHOTO_ALBUM_TYPES.BREEDER,
  PHOTO_ALBUM_TYPES.BREEDER_BREED
];

function isBreederProfilePreviewCategory(category) {
  return (
    PREVIEW_CATEGORIES.includes(category.album_type) && category.show_on_profile
  );
}

function getPreviewCategories(categories) {
  return categories
    .filter(isBreederProfilePreviewCategory)
    .map(cat => cat.name);
}

export default function BreederProfilePhotosCarouselSectionContainer() {
  const dispatch = useDispatch();

  const { breedId, breederProfileId, previewCategories } = useSelector(
    ({ server, queryParams }) => ({
      breedId: queryParams.breed_id,
      breederProfileId: server.breederProfileId,
      previewCategories: getPreviewCategories(server.mediaCategories.data)
    })
  );

  const {
    isLoading,
    value: { data: photographs }
  } = useResourceQuery(
    photographsResourceDefinition(breederProfileId, {
      breed_id: breedId
    })
  );

  const thumbnails = useMemo(() => {
    const categoryPhotos = groupBy(photographs, 'category');

    return previewCategories
      .map(category => {
        const photos = categoryPhotos[category] || [];

        if (isEmpty(photos)) return null;

        return {
          category,
          photo: photos[0],
          count: photos.length
        };
      })
      .filter(Boolean);
  }, [photographs]);

  function handlePhotoClick(photo) {
    dispatch(createBreederProfilePaginationAction(photo.id));
  }

  if (isLoading) {
    return <BreederProfilePhotosCarouselSectionSkeleton />;
  }

  if (isEmpty(thumbnails)) {
    return null;
  }

  return (
    <div className="BreederProfilePhotosCarouselSectionContainer pb8">
      <Divider className="mb6" />
      <BreederProfilePhotosCarousel
        thumbnails={thumbnails}
        onClick={handlePhotoClick}
      />
    </div>
  );
}
